// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditArtistModalContent-deleteButton-2jQIC Button-button-2PYOE Link-link-1rgM9"};